/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SearchPostcodeSuburbInput = {|
  query: string
|};
export type SearchPostcodeSuburbMutationVariables = {|
  input: SearchPostcodeSuburbInput
|};
export type SearchPostcodeSuburbMutationResponse = {|
  +searchPostcodeSuburb: ?{|
    +result: ?any
  |}
|};
export type SearchPostcodeSuburbMutation = {|
  variables: SearchPostcodeSuburbMutationVariables,
  response: SearchPostcodeSuburbMutationResponse,
|};
*/


/*
mutation SearchPostcodeSuburbMutation(
  $input: SearchPostcodeSuburbInput!
) {
  searchPostcodeSuburb(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SearchPostcodeSuburbPayload",
    "kind": "LinkedField",
    "name": "searchPostcodeSuburb",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchPostcodeSuburbMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchPostcodeSuburbMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b52e1f636472b9790e04228f23b11d07",
    "id": null,
    "metadata": {},
    "name": "SearchPostcodeSuburbMutation",
    "operationKind": "mutation",
    "text": "mutation SearchPostcodeSuburbMutation(\n  $input: SearchPostcodeSuburbInput!\n) {\n  searchPostcodeSuburb(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c1f8f50c23b20e3b421ebce3cba08983';

module.exports = node;
